<template>
  <el-dialog
    title="下载APP"
    :visible.sync="dialogVisible"
    width="30%"
    :before-close="handleClose"
    class="modal-dialog"
  >
    <img src="@/assets/img/modal-logo.png" class="modal-logo" alt />
    <img src="@/assets/img/modal-code.png" class="modal-code" alt />
    <div>扫码下载京东金融APP</div>
    <img src="@/assets/img/modal-zan.png" class="modal-zan" alt />
  </el-dialog>
</template>
<script>
export default {
  name: "Modal",

  props: ["dialogVisible"],
  mounted() {},

  methods: {
    handleClose() {
      this.$emit("clsoeModal", false);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/mixin.scss';
::v-deep .el-dialog {
  width: 800px !important;
  height: 464px;
  // margin-top: 35vh !important;
  // transform: translateY(toRem(-132)) !important;
  .el-dialog__header {
    padding: 0;
    height: 48px;
    line-height: 48px;
    padding-left: 24px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid  rgba(0,0,0,0.06);
  }
  .el-dialog__body {
    padding: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    .modal-logo {
      width: 128px;
      height: 105px;
      position: relative;
      z-index: 10;
      margin-top: 46px;
    }
    .modal-code {
      width: 200px;
      height: 200px;
      position: relative;
      z-index: 10;
      margin-top: 10px;
      
    }
    div {
      font-size: 20px;
      font-family: PingFang SC;
      font-weight: 300;
      color: rgba(102, 102, 102, 1);
      line-height: 32px;
      position: relative;
      z-index: 10;
      margin: -15px;
    }
    .modal-zan{
      position: absolute;
      width: 414px;
      height: 358px;
      right: 0;
      bottom: 50px;
    }
  }
}
</style>